"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.run = void 0;
const createUI_1 = require("./functions/ui/createUI");
const pixel_pigeon_1 = require("pixel-pigeon");
const handleWindowMessage_1 = require("./functions/handleWindowMessage");
const loadGameData_1 = require("./functions/loadGameData");
const loadServerURL_1 = require("./functions/loadServerURL");
const postWindowMessage_1 = require("./functions/postWindowMessage");
const processEntitiesInitialPositions_1 = require("./functions/processEntitiesInitialPositions");
const tick_1 = require("./tick");
const run = () => {
    (0, loadServerURL_1.loadServerURL)();
    (0, loadGameData_1.loadGameData)()
        .then(() => {
        (0, processEntitiesInitialPositions_1.processEntitiesInitialPositions)();
        (0, createUI_1.createUI)();
        (0, postWindowMessage_1.postWindowMessage)({ event: "run" });
        (0, pixel_pigeon_1.onWindowMessage)(handleWindowMessage_1.handleWindowMessage);
        (0, pixel_pigeon_1.onTick)(tick_1.tick);
    })
        .catch((error) => {
        (0, pixel_pigeon_1.handleError)(error);
    });
};
exports.run = run;
